import Vue from 'vue'
import Antd from 'ant-design-vue/es';
import 'ant-design-vue/dist/antd.css';

Vue.use(Antd);
// import {Button, LocaleProvider, Pagination,Layout, Avatar, Icon, Input, Dropdown, Menu} from 'ant-design-vue'

// Vue.component(Button.name, Button)
// Vue.component(LocaleProvider.name, LocaleProvider)
// Vue.component(Pagination.name, Pagination)
// Vue.component(Layout.name, Layout)
// Vue.component(Avatar.name, Avatar)
// Vue.component(Icon.name, Icon)
// Vue.component(Input.name, Input)
// Vue.component(Dropdown.name, Dropdown)
// Vue.component(Menu.name, Menu)

// Vue.use(Button)
// Vue.use(LocaleProvider)
// Vue.use(Pagination)
// Vue.use(Layout)
// Vue.use(Avatar)
// Vue.use(Icon)
// Vue.use(Input)
// Vue.use(Dropdown)
// Vue.use(Menu)
